import * as React from 'react';
import { Checkbox, Dialog, DialogContent, DialogTitle, FormControlLabel, IconButton } from '@mui/material';
import HelpIcon from '@material-ui/icons/Help';
import { renderHelpText } from './renderHelpText';

export interface CheckInputFieldProps {
    value?: boolean,
    id?: string,
    name?: string,
    disabled?: boolean,
    style?: React.CSSProperties,
    onChange?: (value: boolean) => void,
    onClick?: (e: React.MouseEvent) => void,
    className?: string,
    label?: React.ReactNode,
    helpText?: string,
}

export const CheckInputField = (props: CheckInputFieldProps) => {
    const {
        value,
        id,
        name,
        disabled,
        style,
        onChange,
        onClick,
        className,
        label,
        helpText,
    } = props;

    const [showHelp, setShowHelp] = React.useState(false);

    const renderedLabel = helpText
        ? (
            <div>
                {label}{' '}
                <IconButton
                    size="small"
                    onClick={e => {
                        e.stopPropagation();
                        setShowHelp(true);
                    }}
                >
                    <HelpIcon />
                </IconButton>
            </div>
        )
        : label;

    return (
        <>
            <FormControlLabel
                style={{ margin: 0, marginBottom: 0, ...style }}
                className={className}
                label={renderedLabel}
                onClick={onClick}
                control={<Checkbox
                    id={id ? `${id}-input` : undefined}
                    style={{ padding: 'var(--spacer-XXS)' }}
                    name={name}
                    disabled={disabled}
                    checked={!!value}
                    onChange={() => onChange && onChange(!value)}
                    className={className}
                />}
            />

            {(helpText?.length &&
                <Dialog open={showHelp} onClose={() => setShowHelp(false)}>
                    <DialogTitle>{label}</DialogTitle>
                    <DialogContent>{renderHelpText(helpText)}</DialogContent>
                </Dialog>
            ) || undefined}
        </>
    );
}
